<div class="fixed-width support-tab tournament-tab">
  <mat-tab-group *ngIf="isRegularTournament else networkTournament" mat-stretch-tabs [selectedIndex]="tabIndex" (selectedTabChange)="onTabChange($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="{{licenceService.getKey('icon-how-works')}}">
        <span i18n>Info</span>
      </ng-template>
      <app-how-it-works [tournament]="regularTournament"></app-how-it-works>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img class="icon-label" src="{{licenceService.getKey('icon-leader')}}">
        <span i18n>Leaderboard</span>
      </ng-template>
      <app-leader-board [ref]="regularTournament.ref" [tournament]="regularTournament"></app-leader-board>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img class="icon-label" src="{{licenceService.getKey('icon-prize')}}">
        <span i18n>Prizes</span>
      </ng-template>
      <app-prizes-scoring [tournament]="regularTournament"></app-prizes-scoring>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img class="icon-label" src="{{licenceService.getKey('icon-score')}}">
        <span i18n>Scoring</span>
      </ng-template>
      <app-points-scoring [tournament]="regularTournament"></app-points-scoring>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #networkTournament>
  <div class="game-card-wrap">
    <app-how-it-works [tournament]="tournament"></app-how-it-works>
  </div>
</ng-template>